import { navigate } from '@reach/router'

const goBack = (): Promise<void> => navigate(-1)

export default goBack
